export type ActionHeader = {
    title: string;
    text: string;
    value: 'actions';
    key: 'actions';
    sortable: false;
    align: 'end';
    width: '1%';
};

export function actionsHeader(): ActionHeader {
    return {
        title: 'Actions',
        text: 'Actions',
        value: 'actions',
        key: 'actions',
        sortable: false,
        align: 'end',
        width: '1%',
    };
}
